/** eslint-disable react-hooks/exhaustive-deps */
import { useContext as reactUseContext, createContext as reactCreateContext, useMemo } from "react"
import once from "lodash.once"

export function createContextOnce() {
  return once(<T,>() => reactCreateContext<T | undefined>(undefined))
}

export function useContext<T>(Context: React.Context<T | undefined>, consumerName: string) {
  const context = reactUseContext(Context)

  if (context === undefined) {
    throw new Error(`${consumerName} must be used within its Root Component`)
  }

  return context
}

export function createProviderForContext<T>(Context: React.Context<T | undefined>) {
  const Provider = (props: T & { children: React.ReactNode }) => {
    const { children, ...providerProps } = props

    // Only re-memoize when prop values change
    const value = useMemo(() => providerProps, Object.values(providerProps)) as unknown as T

    return <Context.Provider value={value}>{children}</Context.Provider>
  }

  return Provider
}
